import { useTheme } from "styled-components";
import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  InfoCard,
  IDateRange,
  ModalContext,
  DatePeriodTypesEnum,
  useCheckIfSubscriptionFeatureActiveBroker,
  getPeriodRangeByPeriodType,
  PaginationProvider,
  ViewerContext,
} from "dash-ui";
import { DashFeaturesEnum } from "dash-common";

import Property from "assets/images/png/Property.png";
import { useGetNumberOfPortfolioPropertiesChangelogsLazyQuery } from "gql/generated.graphql";
import { RoutesPath } from "flow-components/routes/routes";

import { PropertyUpdatesModal } from "./components";

function PropertyUpdatesWidget() {
  const theme = useTheme();
  const navigate = useNavigate();
  const { t: tCommon } = useTranslation("common", { keyPrefix: "labels" });
  const { t } = useTranslation("pages", {
    keyPrefix: "dashboardPage.propertyUpdatesWidget",
  });
  const [countOfUpdates, setCountOfUpdates] = useState<number>(0);
  const [range, setRange] = useState<IDateRange>(
    getPeriodRangeByPeriodType(DatePeriodTypesEnum.CURRENT_WEEK)
  );
  const [type, setType] = useState<DatePeriodTypesEnum>(
    DatePeriodTypesEnum.CURRENT_WEEK
  );
  const { toggleModal, setPayload } = useContext(ModalContext);
  const { broker } = useContext(ViewerContext);
  const [
    lazyGetNumberOfPortfolioPropertiesChangelogs,
    { loading: infoLoading },
  ] = useGetNumberOfPortfolioPropertiesChangelogsLazyQuery();
  const { checkFeatureAccess } = useCheckIfSubscriptionFeatureActiveBroker([
    DashFeaturesEnum.PORTFOLIO_CREATION_AND_SHARING,
  ]);

  return (
    <PaginationProvider>
      <>
        <PropertyUpdatesModal />
        <InfoCard
          range={range}
          ml={6}
          loading={infoLoading}
          hasInfoData={!!countOfUpdates}
          infoDescription={t("infoDescription")}
          infoPlaceholderDescription={t("infoPlaceholderDescription")}
          infoPlaceholder={{
            iconName: "visibility",
            info: t("infoPlaceholder") || "",
          }}
          bgColor={theme.colors.b50}
          buttonTitle={tCommon(countOfUpdates ? "view" : "create")}
          bgImgSrc={Property}
          onButtonClick={() => {
            if (countOfUpdates) {
              setPayload({ range, type });

              return toggleModal(true, "PropertyUpdatesModal");
            }

            if (checkFeatureAccess()) {
              return navigate(RoutesPath.Portfolios);
            }
          }}
          itemsInfo={[
            { info: countOfUpdates, iconName: "visibility", key: "visibility" },
          ]}
          onRangeChange={async (
            dateRange: IDateRange,
            type: DatePeriodTypesEnum
          ) => {
            setRange(dateRange);
            setType(type);

            if (broker) {
              const { data } =
                await lazyGetNumberOfPortfolioPropertiesChangelogs({
                  variables: { dateRange },
                });
              const { getNumberOfPortfolioPropertiesChangelogs = 0 } =
                data || {};

              setCountOfUpdates(getNumberOfPortfolioPropertiesChangelogs);
            }
          }}
        />
      </>
    </PaginationProvider>
  );
}

export default PropertyUpdatesWidget;
